import { Module, ActionTree, MutationTree, GetterTree } from 'vuex'
import { authAxios } from './utils'
import { RootState } from '@/store'
import { socket } from '@/main'
import axios from 'axios'

export type AuthState = {
  isAuthenticated: boolean | null,
  isTwoFactorAuthenticated: boolean | null,
  authenticationTime: Date | null,
  mediaUrl: string | null,
  customerPortalUrl: string | null,
  givenName: string | null,
  surname: string | null,
  id: number | null,
  agencyId: number | null,
  isShowingSessionExpiredModal: boolean,
  isMigrationAgency: boolean,
  isTranslationAgency: boolean
}

class AuthStore implements Module<AuthState, RootState> {
  namespaced = true

  state = () => ({
    isAuthenticated: null,
    isTwoFactorAuthenticated: null,
    authenticationTime: null,
    givenName: null,
    surname: null,
    id: null,
    agencyId: null,
    isShowingSessionExpiredModal: false,
    mediaUrl: null,
    customerPortalUrl: null,
    isTranslationAgency: false,
    isMigrationAgency: false
  })

  getters?: GetterTree<AuthState, RootState> = {
    isTranslationAgency(state) {
      return state.isTranslationAgency
    },
    isMigrationAgency(state) {
      return state.isMigrationAgency
    }
  }

  mutations: MutationTree<AuthState> = {
    logout(state) {
      state.isAuthenticated = false
      state.isTwoFactorAuthenticated = false
      state.authenticationTime = null
      state.mediaUrl = null
      state.customerPortalUrl = null
      state.givenName = null
      state.surname = null
      state.id = null
      state.agencyId = null
      state.isTranslationAgency = false
      state.isMigrationAgency = false

      if (socket().connected) {
        socket().disconnect()
      }
    },
    update(state, newData) {
      const isLoggingIn = !state.isTwoFactorAuthenticated && newData.isTwoFactorAuthenticated
      state.isAuthenticated = newData.isAuthenticated
      state.isTwoFactorAuthenticated = newData.isTwoFactorAuthenticated
      state.mediaUrl = newData.mediaUrl
      state.customerPortalUrl = newData.customerPortalUrl
      state.agencyId = newData.agencyId

      if (newData.agent) {
        state.givenName = newData.agent.givenName
        state.surname = newData.agent.surname
        state.agencyId = newData.agent.agencyId
        state.id = newData.agent.id
        state.isTranslationAgency = !!newData.agent.isTranslationAgency
        state.isMigrationAgency = !!newData.agent.isMigrationAgency
      }


      if (isLoggingIn) {
        if (socket().connected) {
          // If the user still has an active socket connection while they were logged out, this needs to be closed.
          socket().disconnect()
        }

        socket().connect()
      }
    },
    updateAccountType  (state, payload) {
      state.isMigrationAgency = !!payload.isMigrationAgency
      state.isTranslationAgency = !!payload.isTranslationAgency
    },
    setExpiredModalVisibility(state, value) {
      state.isShowingSessionExpiredModal = value
    }
  }

  actions: ActionTree<AuthState, RootState> = {
    async refresh({ commit }) {
      try {
        const response = await authAxios.get<any>('')
        const agent = await axios.get<any>('profile')

        const combinedData = { ...response.data, agent: agent.data };

        commit('update', combinedData)

        commit('SET_ACCEPTED_TERMS', !!combinedData.acceptedTerms, { root: true })
        return true
      } catch (error) {
        return false
      }
    },
    expire({ commit }) {
      commit('setExpiredModalVisibility', true)
      commit('logout')
    },
    updateAccountType  ({ commit }, payload) {
      commit('updateAccountType', payload)
    }
  }
}

export default new AuthStore()
